<template>
  <v-card class="sellerProductStatistic" flat>
    <AdminToolbar
      :searchTypes="searchTypes" 
      :search_condition.sync="search_condition"
      :sortTypes="sortTypes"
      :sort.sync="sort"
      :tabs="tabs"
      :tab.sync="tab"
      @searching="searching"
    ></AdminToolbar>

    <div class="table" v-infinite-scroll="getProductStatistic" infinite-scroll-disabled="busy" infinite-scroll-distance="150">
      <v-row class="table-header" no-gutters>
        <v-col>主播</v-col>
        <v-col class="text-left">商品</v-col>
        <v-col>編號</v-col>
        <v-col>建立時間</v-col>
        <v-col v-if="tab == 1">結束時間</v-col>
        <v-col v-if="tab == 2">照片數</v-col>
        <v-col v-if="tab == 2">影片數</v-col>
        <v-col>售價</v-col>
        <v-col v-if="tab != 3">解鎖數</v-col>
        <v-col v-if="tab != 3">按讚率</v-col>
        <v-col v-if="tab != 3">點擊數</v-col>
        <v-col v-if="tab != 3">總售出桃子</v-col>
        <v-col v-if="tab == 3">是否售出</v-col>
        <v-col v-if="tab == 3">售出時間</v-col>
      </v-row>

      <div class="table-body">
        <template v-for="product in products">
          <v-row class="table-content" no-gutters :key="product.id">
            <v-col>
              <v-avatar size="40" class="mr-2">
                <v-img :src="$HOST_URL + product.seller.usericon"/>
              </v-avatar>
                {{ product.seller.nickname }}
            </v-col>
            <v-col class="text-left">
              <v-avatar size="40" class="mr-2">
                <v-img :src="$func.productImagePreview(product)"/>
              </v-avatar>
              {{ product.title }}
            </v-col>
            <v-col>
              {{ product.id | filter(product.product_type) }}
            </v-col>
            <v-col>
              {{ product.created_at | formatDate }}
            </v-col>
            <v-col v-if="tab == 1">
              {{ $moment(product.created_at).add(3, 'M') | formatDate }}
            </v-col>
            <v-col v-if="tab == 2">
              {{ product.image_info.length }}
            </v-col>
            <v-col v-if="tab == 2">
              {{ product.video_info.length }}
            </v-col>
            <v-col>
              <div class="peach"></div>
              {{ product.price }}
            </v-col>
            <v-col v-if="tab != 3">
              {{ product.unlocks }}
            </v-col>
            <v-col v-if="tab != 3">
              {{ mul(product.praise_rate, 100) }}%
            </v-col>
            <v-col v-if="tab != 3">
              {{ product.views }}
            </v-col>
            <v-col v-if="tab != 3">
              <div class="peach"></div>
              {{ product.total_sold }}
            </v-col>
            <v-col v-if="tab == 3">
              <span v-if="product.sold" class="green--text">是</span>
              <span v-else class="red--text">否</span>
            </v-col>
            <v-col v-if="tab == 3">
              {{ product.sold_at | formatDate }}
            </v-col>
          </v-row>
        </template>
      </div>
    </div>
  </v-card>
</template>

<script>
import AdminToolbar from '@/components/admin/AdminToolbar'
export default {
  components: { AdminToolbar },
  data() {
    return {
      busy: false,
      page: 1,
      searchTypes: [
        { text: '手機號碼', table: 'sellers', column: 'tel' },
        { text: '主播暱稱', table: 'sellers', column: 'nickname' },
      ],
      sortTypes: [
        { text: '建立日期', table: 'products', column: 'created_at', by: 'desc' },
      ],
      sort: '',
      tabs: [
        {text: '長片', value: 'video'},
        {text: '動態', value: 'story'},
        {text: '寫真', value: 'photo'},
        {text: '原味衣物', value: 'clothes'},
        {text: '聊天解鎖', value: 'chat'},
      ],
      tab: 0,
      search_condition: [],
      products: []
    }
  },
  methods: {
    searching() {
      this.busy = false
      this.page = 1
      this.products = []
      this.getProductStatistic()
    },
    getProductStatistic() {
      this.busy = true
      let origin = this.tab
      this.axios(`/admin/products/statistics?product_type=${this.tabs[this.tab].value}&page=${this.page}&size=50`).then(response => {
        if(origin != this.tab) {
          return
        }
        this.products = this.products.concat(response.data.data)
        if(this.page != response.data.last_page) {
          this.page += 1
          this.busy = false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.sellerProductStatistic {

}
</style>